
import LoginDeailsService from '../../services/logindetails.service';


export default function ApiGet() {
    return new Promise((resolve, reject) => {
        const columnMaps = new Map(); // NOSONAR
            LoginDeailsService.CallLoginAPI()
                .then((response) => {
                    if (response.status === 200) {                     
                        sessionStorage.setItem('companyName', response.data.companyName);
                        const apiURL = response.data.apiurl;
                         columnMaps.set("apiURL", apiURL);
                         resolve(apiURL);
                    } else {
                        console.error("Error while fetching user data. Status:", response.status);
                        console.error("Error Message:", response.data);
                        
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    reject(error);
                });
      
    });
}


